import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import HeroSection from "../components/cargo/HeroSection";
import AboutUs from "../components/cargo/aboutUs";
import Services from "../components/cargo/Services";
import FleetServices from "../components/cargo/FleetServices";
import WhyChooseUs from "../components/cargo/WhyChooseUs";
import Testimonials from "../components/cargo/Testimonials";
import TickerBanner from "../components/cargo/TickerBanner";
import GlobalFootprints from "../components/cargo/GlobalFootprints";
import LatestNews from "../components/cargo/LatestNews";
import FAQ from "../components/cargo/FAQ";
import Partners from "../components/cargo/Partners";
import RequestQuote from "../components/cargo/RequestQuote";
import Footer from "../components/cargo/Footer";

export default function Cargo() {
    const [showTopButton, setShowTopButton] = useState(false);
    const { i18n } = useTranslation();

    useEffect(() => {
        const handleScroll = () => {
            setShowTopButton(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const direction = i18n.language === "ar" ? "rtl" : "ltr";

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <div
            dir={direction}
            className="scrollbar-hide relative overflow-y-scroll bg-white"
        >
            <HeroSection />
            <AboutUs />
            <Services />
            <FleetServices />
            <WhyChooseUs />
            <Testimonials />
            <TickerBanner />
            <GlobalFootprints />
            <LatestNews />
            <FAQ />
            <Partners />
            <RequestQuote />
            <Footer />

            {showTopButton && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-8 right-16 z-50 hover:scale-110 transition-transform"
                    aria-label="Back to top"
                >
                    <svg
                        width="52"
                        height="52"
                        viewBox="0 0 72 72"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g filter="url(#filter0_d_577_33167)">
                            <rect
                                x="4"
                                width="64"
                                height="64"
                                rx="32"
                                fill="#00B9EC"
                            />
                            <path
                                d="M35.9998 24.5788L22.9839 37.5947L24.8322 39.4429L29.2836 34.9655L35.9998 28.2493L42.716 34.9655L47.1674 39.4169L49.0156 37.5687L35.9998 24.5788Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <filter
                                id="filter0_d_577_33167"
                                x="0"
                                y="0"
                                width="72"
                                height="72"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                            >
                                <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                />
                                <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_577_33167"
                                />
                                <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_577_33167"
                                    result="shape"
                                />
                            </filter>
                        </defs>
                    </svg>
                </button>
            )}
        </div>
    );
}
